import { Flex, xcss } from '@atlaskit/primitives';

import { RightHandSideProps } from '../../../common/types.tsx';
import { useGetSelectedCodingAgentAvatarsFromSearchParams } from '../../../controllers/index';
import { BoardColumnsSvg } from '../../assets/board-columns-svg.tsx';
import { ProjectSvg, type Injections } from '../../assets/project-svg.tsx';

import { ColumnHighlight } from './column-highlight.tsx';

export const RightHandSidePageBoardColumns = ({
	projectName,
	columnNames,
}: RightHandSideProps & { columnNames: string[] }) => {
	const assignedAgents = useGetSelectedCodingAgentAvatarsFromSearchParams();
	const injections: Injections = {
		additionalObject: ColumnHighlight,
		svgBody: BoardColumnsSvg({
			columnNames,
			assignedAgents,
		}),
	};

	return (
		<Flex alignItems="center" justifyContent="center" xcss={containerStyles}>
			<ProjectSvg projectName={projectName} activeView="board" injections={injections} />
		</Flex>
	);
};
const containerStyles = xcss({
	height: '100%',
	backgroundColor: 'elevation.surface',
});
